// extracted by mini-css-extract-plugin
export default {"page":"J0-z","cartModal":"K0-z","checkout":"L0-z","placeholder":"M0-z","account":"N0-z"};